import { Button } from "@/components/ui/button/button";
import { BwCloseLine } from "@/components/ui/icons";

type ActiveFilterRemoveProps = {
  onClick: () => void;
};

export const ActiveFilterRemove = ({ onClick }: ActiveFilterRemoveProps) => {
  return (
    <Button
      data-test="active-filter-remove"
      kind="ghost"
      size="icon-xs"
      onClick={onClick}
      className="cursor-pointer bg-bg-dark-min border-t border-r border-b border-border-dark-min rounded-l-none rounded-r-lg size-6 text-text-dark-high hover:bg-bg-dark-low transition shrink-0"
    >
      <BwCloseLine className="size-4" />
    </Button>
  );
};
